var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaitech({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 216.21 118.24",
    style: {
      enableBackground: "new 0 0 216.21 118.24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#849938;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.4,62.09c5.94-0.6,11.58-0.84,18.66-0.84c9.54,0,13.86,3.48,13.86,9.84c0,6.48-2.76,11.82-9.9,14.58 c0.6,1.38,1.26,2.94,1.86,4.5l4.56,11.88H18.78l-4.62-14.76h-0.42l-2.82,14.76H0l6.12-32.22c-1.38-0.24-3.3-0.48-5.04-0.6 L2.4,62.09z M19.2,70.43c-0.9,0-1.92,0.06-2.28,0.12l-1.62,8.7c0.42,0.06,1.14,0.12,1.74,0.12c3.84,0,6.12-3,6.12-6 C23.16,71.57,21.96,70.43,19.2,70.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.96,102.05c0,0-1.74,0.12-6.6,0.12c-1.26,0-2.52,0-3.78-0.06c0.48-2.04,0.9-3.66,1.74-5.7H52.2 c-2.82,4.2-6.36,6.42-10.5,6.42c-4.92,0-7.5-3.18-7.5-9.72c0-11.64,6.6-21.6,19.74-21.6c3.9,0,8.22,0.24,12.36,1.02 C62.58,91.73,60.96,102.05,60.96,102.05z M52.02,80.09c-4.08,0-6.72,6.36-6.72,10.92c0,1.56,0.24,2.34,1.14,2.34 c2.28,0,6.42-6.72,7.38-11.7l0.24-1.26C53.46,80.21,52.86,80.09,52.02,80.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.26,102.05H68.52l4.14-21.48v-0.12c-1.38-0.24-3.3-0.48-5.04-0.6l1.32-7.14 c4.98-0.54,10.32-0.72,16.02-0.54L79.26,102.05z M80.76,69.95c-3.66,0-6.12-2.82-6.12-5.88c0-3.9,3.36-6.72,6.96-6.72 c3.6,0,6.12,2.82,6.12,5.76C87.72,67.13,84.36,69.95,80.76,69.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.86,80.63h-5.46l-1.92,10.38c-0.36,2.1,0,2.7,1.68,2.7c1.26,0,2.22-0.18,3.18-0.36l-1.26,8.52 c-2.28,0.6-4.92,0.9-6.9,0.9c-6.84,0-9-3.24-7.56-10.98l2.1-11.16H87l1.68-8.4h3.6l1.62-8.4l11.1-2.1l-1.98,10.5h5.52 L106.86,80.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.92,91.25v0.72c0,1.62,0.78,2.34,4.02,2.34c2.88,0,6.06-0.66,9.06-1.8v8.22 c-3.9,1.32-8.34,2.04-12.36,2.04c-8.7,0-11.34-4.38-11.34-10.74c0-13.74,9.18-20.52,17.52-20.52c9,0,10.98,4.38,10.98,8.04 C136.8,87.71,129.06,91.07,118.92,91.25z M124.68,79.49c-2.64,0-4.08,2.7-4.8,5.04c3.66-0.06,6.54-0.9,6.54-3.54 C126.42,80.09,125.88,79.49,124.68,79.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.94,81.47c-1.02-0.42-2.16-0.6-3.36-0.6c-4.44,0-6.3,4.68-6.3,8.58c0,2.34,1.32,3.72,3.84,3.72 c1.32,0,2.76-0.18,4.02-0.6l-1.14,9.48c-1.98,0.6-4.14,0.84-6.18,0.84c-8.22,0-11.88-4.02-11.88-11.04 c0-11.52,7.14-20.4,18.12-20.4c1.86,0,3.6,0.18,5.4,0.54L158.94,81.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.06,102.05h-10.74l3.48-18.18c0.42-2.22,0.18-2.94-0.6-2.94c-1.86,0-6.18,6-7.38,12.24l-1.68,8.88H161.4 l6.78-35.58c-1.38-0.24-3.3-0.48-5.04-0.6l1.32-7.14c4.98-0.54,10.32-0.72,16.02-0.54l-1.98,10.62c-0.6,3.12-1.74,6.3-3.06,9.06 h0.12c2.64-3.84,5.94-6.42,10.8-6.42c6.12,0,7.68,4.38,6.66,9.66L189.06,102.05z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.15,22.79C212.49,15.4,215.05,4.46,216.21,0c-2.9,3.98-9.35,6.39-13.5,7.4 c-3.78,0.92-11.1,1.93-18.09,5.3c-6.95,3.34-9.73,9.03-11.77,13.37c-2.24,4.77-3.49,12.3-3.49,12.3 C177.46,28.98,182.76,28.08,195.15,22.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.25,30.52c-17.33,7.4-19.9,18.34-21.06,22.8c2.89-3.98,9.35-6.39,13.5-7.39 c3.78-0.92,11.1-1.93,18.09-5.3c6.95-3.34,9.73-9.03,11.77-13.37c2.24-4.77,3.49-12.3,3.49-12.3 C204.95,24.34,199.64,25.24,187.25,30.52z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaitech);
export default __webpack_public_path__ + "static/media/Raitech.f53d7882fdda71f5e5bc6fbe0e563af2.svg";
export { ForwardRef as ReactComponent };